import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaymentResult from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import FAQ from "./Component/FAQ";
import CookiePolicy from "./Component/CookiePolicy";
import Accessibility from "./Component/Accessibility";
import PolicyIndex from "./Component/PolicyIndex";
import ConsumerDataRights from "./Component/ConsumerDataRights";
import TermsOfSale from "./Component/TermsOfSale";
import DeliveryIssues from "./Component/DeliveryIssues";
import OrderCancellation from "./Component/OrderCancellation";
import InternationalOrders from "./Component/InternationalOrders";
import PaymentPolicy from "./Component/PaymentPolicy";
import ProductInformation from "./Component/ProductInformation";
import ProductSafety from "./Component/ProductSafety";
import IntellectualProperty from "./Component/IntellectualProperty";
import PackagingPolicy from "./Component/PackagingPolicy";
import ComplaintsPolicy from "./Component/ComplaintsPolicy";
import ContactPolicy from "./Component/ContactPolicy";

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms-of-sale" element={<TermsOfSale />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/data-rights" element={<ConsumerDataRights />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/policies" element={<PolicyIndex />} />
          <Route path="/delivery-issues" element={<DeliveryIssues />} />
          <Route path="/cancellations" element={<OrderCancellation />} />
          <Route path="/international-orders" element={<InternationalOrders />} />
          <Route path="/payment-policy" element={<PaymentPolicy />} />
          <Route path="/product-information" element={<ProductInformation />} />
          <Route path="/product-safety" element={<ProductSafety />} />
          <Route path="/intellectual-property" element={<IntellectualProperty />} />
          <Route path="/packaging" element={<PackagingPolicy />} />
          <Route path="/complaints" element={<ComplaintsPolicy />} />
          <Route path="/contact-policy" element={<ContactPolicy />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/payment" element={<PaymentResult />} />
          <Route path="/paysuccess" element={<PaymentResult />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
